export default __webpack_public_path__ + "static/media/Sans-titre2.42294b70.png";